import Button from '@/components/Button/Button';
import { PATH } from '@/constants/path';
import { JobSearchWebCriteria } from '@/types/jobs';
import { pushGtmEvent } from '@/utils/gtm';
import { useAnalytics } from '@/utils/useAnalytics';
import cx from 'classnames';
import React from 'react';

import styles from './JobListingRegisterCtaBanner.module.scss';
import BackgroundGraphic from './imgs/backgroundGraphic.svg';
import BackgroundGraphicMobile from './imgs/backgroundGraphicMobile.svg';
import CheckCircleIcon from './imgs/checkCircle.svg';

export type JobListingRegisterCtaBannerProps =
  | {
      suppressCTABanner: true;
    }
  | {
      suppressCTABanner?: false;
      isUserLoggedIn: boolean;
      position: number; // the index of this banner in the results list
      query: JobSearchWebCriteria; // the criteria for the search that resulted in this banner being shown
    };

const HIGHLIGHTS = ['We search for you', 'Early job access', 'Travel & accom paid'];

const JobListingRegisterCtaBanner = (props: JobListingRegisterCtaBannerProps) => {
  const track = useAnalytics();

  if (props.suppressCTABanner) {
    return null;
  }
  const { isUserLoggedIn, position, query } = props;
  if (isUserLoggedIn) {
    return null;
  }

  const handleRegisterClick = () => {
    track('Job Search Register CTA click', {
      position,
      grade: query.grade ?? 'none',
      speciality: query.speciality ?? 'none',
    });
    pushGtmEvent({
      event: 'register_click',
      element: 'Register',
      event_label: 'cta_banner_register',
    });
  };

  return (
    <article className={styles.container} data-testid="job-list-register-cta">
      <BackgroundGraphic
        className={cx(styles.backgroundGraphic, styles.backgroundGraphicDesktop)}
        aria-hidden="true"
      />
      <BackgroundGraphicMobile
        className={cx(styles.backgroundGraphic, styles.backgroundGraphicMobile)}
        aria-hidden="true"
      />
      <h2 className={styles.heading}>Access our free service, designed to save you time</h2>
      <div className={styles.row}>
        <ul className={styles.highlightList}>
          {HIGHLIGHTS.map(highlight => (
            <li className={styles.highlight} key={highlight}>
              <CheckCircleIcon className={styles.highlightIcon} aria-hidden="true" />
              <span>{highlight}</span>
            </li>
          ))}
        </ul>
        <Button
          href={PATH.REGISTER}
          colorVariant="secondary"
          className={styles.registerButton}
          onClick={handleRegisterClick}
          trackFunction={null}
        >
          Register
        </Button>
      </div>
    </article>
  );
};

export default JobListingRegisterCtaBanner;
